<script setup lang="ts">
type Emits = {
  close: [];
};

const emit = defineEmits<Emits>();

function onCloseButtonClick() {
  emit('close');
}
</script>

<template>
  <div :class="$style.reactivateAccount">
    <div :class="$style.title">
      <span> ⚠️ Ação necessária ⚠️ </span>
    </div>

    <div :class="$style.description">
      <span>
        Notamos que sua <strong>senha atual não é segura</strong> o suficiente.
        Para proteger melhor sua conta, pedimos que você
        <strong>crie uma nova senha</strong> antes de continuar usando nossos
        serviços.
      </span>
    </div>

    <div :class="$style.button">
      <button @click.prevent="onCloseButtonClick">
        <NuxtIcon name="arrows/arrow_right" />
        Redefinir senha
      </button>
    </div>
  </div>
</template>

<style module lang="postcss">
.reactivateAccount {
  @apply text-center px-6 py-2 w-full h-full z-50 text-auth-texts flex flex-col gap-4;

  .title {
    @apply text-sm font-bold uppercase;
  }

  .description {
    @apply text-sm flex flex-col gap-4 font-medium;

    small {
      @apply text-xs rounded-md p-4 m-0;
    }
  }

  .button {
    @apply flex items-center justify-center flex-col gap-1;

    span {
      @apply text-2xs font-semibold text-auth-texts/50;
    }

    button {
      @apply text-xs font-bold flex items-center gap-2 bg-auth-button-bg/20 text-auth-button-bg/90 px-4 py-2 rounded-md;

      svg {
        @apply text-auth-button-bg/90;
      }
    }
  }
}
</style>
